import { Component, input, output } from '@angular/core';
import { VoyageRoutesPortcall } from '../voyage-routes-portcall/voyage-routes-portcall';
import { VoyageRoutesSegment } from '../voyage-routes-segment/voyage-routes-segment';
import { ButtonContext, ButtonType, ModalMode } from '@solcre-org/core-ui';
import { TranslateModule } from '@ngx-translate/core';
import { VoyageRouteView } from '../voyage-route-view.enum';
import { PortCallModel } from '../../../../shared/models/port-call.model';
import { VoyageSummaryModel } from '../../../../shared/models/voyage-summary.model';

@Component({
  selector: 'app-voyage-route',
  imports: [VoyageRoutesPortcall, VoyageRoutesSegment, TranslateModule],
  templateUrl: './voyage-route.html',
})
export class VoyageRoute {
  //Inputs and outputs
  addPortCall = output<number>();
  editPortCall = output<PortCallModel>();
  editNauticalMileDistance = output<PortCallModel>();
  deletePortCall = output<PortCallModel>();
  changePortcallAsActive = output<PortCallModel>();
  changeStatus = output<PortCallModel>();
  expensesUpdated = output<PortCallModel>();
  addExpensesAction = output<PortCallModel>();
  speedSelectionUpdated = output<PortCallModel>();
  addSpeedSelectionAction = output<PortCallModel>();
  activeVoyage = input<VoyageSummaryModel | null>(null);
  activePortCall = input<PortCallModel | null>(null);
  nextPortCall = input<PortCallModel | null>(null);
  activeRouteView = input<VoyageRouteView>(VoyageRouteView.card);

  //Models
  buttonTypes = ButtonType;
  buttonContexts = ButtonContext;
  modalmodes = ModalMode;

  onAddPortCall(sequenceOrder: number): void {
    this.addPortCall.emit(sequenceOrder);
  }

  onEditPortCall(porCall: PortCallModel): void {
    this.editPortCall.emit(porCall);
  }

  onEditNauticalMileDistance(porCall: PortCallModel): void {
    this.editNauticalMileDistance.emit(porCall);
  }

  onDeletePortCall(porCall: PortCallModel): void {
    this.deletePortCall.emit(porCall);
  }

  onChangePortCallAsActive(porCall: PortCallModel): void {
    this.changePortcallAsActive.emit(porCall);
  }

  onChangeStatus(porCall: PortCallModel): void {
    this.changeStatus.emit(porCall);
  }

  onExpensesUpdated(porCall: PortCallModel): void {
    this.expensesUpdated.emit(porCall);
  }

  onAddExpenses(porCall: PortCallModel): void {
    this.addExpensesAction.emit(porCall);
  }

  onSpeedSelectionUpdated(porCall: PortCallModel): void {
    this.speedSelectionUpdated.emit(porCall);
  }

  onAddSpeedSelection(porCall: PortCallModel): void {
    this.addSpeedSelectionAction.emit(porCall);
  }
}
